import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-modal-acelera-mais',
  templateUrl: './modal-acelera-mais.component.html',
  styleUrls: ['./modal-acelera-mais.component.scss'],
})
export class ModalAceleraMaisComponent {
  @Output() onCloseAceleraMais: EventEmitter<boolean> = new EventEmitter();

  constructor(private bsModalRef: BsModalRef) { }

  onClickClose() {
    this.bsModalRef.hide();
    this.onCloseAceleraMais.next(true);
  }

  redirectUser() {
    window.open(
      'https://www.clubeomni.com.br/',
      '_blank'
    );
    this.onClickClose();
  }
}
